<template>
  <div id="app">
    <router-view/>
    <CustomerService v-if="showCustomerService" />
  </div>
</template>

<script>
import CustomerService from './components/CustomerService.vue'

export default {
  name: 'App',
  components: {
    CustomerService
  },
  computed: {
    showCustomerService() {
      return !(this.$route && this.$route.meta && this.$route.meta.hideCustomerService)
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-size: 14px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 全局容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  html, body {
    font-size: 13px;
  }

  .container {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  html, body {
    font-size: 12px;
  }

  .container {
    padding: 0 10px;
  }
}

/* 防止移动端横向滚动 */
* {
  box-sizing: border-box;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
